import { OccupancyRate } from "../averageRate/OccupancyRate";
import { AverageTarif } from "../loadLevel/AverageTarif";
import { PaycheckComplete } from "../paycheck/PaycheckComplete";

export const ThreeCardsMarkup = ({block, textPaycheck, CustomBox}) => {
  // console.log(block);
  return (
    <>
      <OccupancyRate occupancy={block.occupancy} CustomBox={CustomBox} />
      <AverageTarif averageTarif={block.averageTarif} CustomBox={CustomBox} />
      <PaycheckComplete text={textPaycheck} income={block.income} CustomBox={CustomBox} />
    </>
  );
};
